import { Identificator } from './custom-types';
import { Slownik } from './slownik';

export class Adres {
  czyAdresZagraniczny!: boolean;
  adres!: AdresDomowy | null;
  adresZagraniczny!: AdresZagraniczny | null;
}

export class AdresZagraniczny {
  id!: Identificator;
  panstwo!: Slownik | null;
  gminaDzielnica!: string | null;
  miejscowosc!: string | null;
  ulica!: string | null;
  nrDomu!: string | null;
  nrLokalu!: string | null;
  kodPocztowyZagraniczny!: string | null;
}

export class AdresDomowy {
  id!: Identificator;
  gminaDzielnica!: Slownik | null;
  kodPocztowy!: string | null;
  poczta!: string | null;
  miejscowosc!: Slownik | null;
  ulica!: Slownik | null;
  nrDomu!: string | null;
  nrLokalu!: string | null;
}
